import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const sectionTypeKeys = {
  [Node_Type.BLOCKQUOTE]: "LinkTo_Modal_Section_Item_Quote",
  [Node_Type.BUTTON]: "LinkTo_Modal_Section_Item_Button",
  [Node_Type.CODE_BLOCK]: "LinkTo_Modal_Section_Item_Codeblock",
  [Node_Type.FILE]: "LinkTo_Modal_Section_Item_File",
  [Node_Type.GALLERY]: "LinkTo_Modal_Section_Item_Gallery",
  [Node_Type.GIF]: "LinkTo_Modal_Section_Item_GIF",
  [Node_Type.HEADING]: "LinkTo_Modal_Section_Item_Heading",
  [Node_Type.IMAGE]: "LinkTo_Modal_Section_Item_Image",
  [Node_Type.PARAGRAPH]: "LinkTo_Modal_Section_Item_Paragraph",
  [Node_Type.VIDEO]: "LinkTo_Modal_Section_Item_Video"
};
export {
  sectionTypeKeys
};
//# sourceMappingURL=section-type-keys.js.map
